var map = {
	"./ae.svg": "048f",
	"./al.svg": "5cf4",
	"./am.svg": "e428",
	"./az.svg": "3611",
	"./bg.svg": "a41b",
	"./by.svg": "eee4",
	"./cn.svg": "35e6",
	"./cz.svg": "177d",
	"./de.svg": "7e20",
	"./dk.svg": "b1f9",
	"./en.svg": "ebb2",
	"./es.svg": "2bcf",
	"./fi.svg": "c70c",
	"./fr.svg": "4b32",
	"./gb.svg": "02c1",
	"./ge.svg": "2565",
	"./gr.svg": "fcdf",
	"./hr.svg": "0f8a",
	"./hu.svg": "acb0",
	"./id.svg": "2358",
	"./ie.svg": "2a70",
	"./il.svg": "3c23",
	"./in.svg": "e813",
	"./ir.svg": "d44f",
	"./is.svg": "3c56",
	"./it.svg": "fe62",
	"./jp.svg": "d85a",
	"./kr.svg": "ef33",
	"./kz.svg": "141f",
	"./lt.svg": "028a",
	"./lu.svg": "61c7",
	"./lv.svg": "8636",
	"./mg.svg": "2b73",
	"./mk.svg": "d524",
	"./mn.svg": "cfa0",
	"./my.svg": "0941",
	"./nl.svg": "84ab",
	"./no.svg": "185b",
	"./nz.svg": "d47b",
	"./pl.svg": "74ed",
	"./pt.svg": "b96b",
	"./question-mark.svg": "4c03",
	"./ro.svg": "b550",
	"./ru.svg": "e643",
	"./se.svg": "400f",
	"./sk.svg": "b382",
	"./sl.svg": "9fbf",
	"./sr.svg": "7108",
	"./th.svg": "2a14",
	"./tj.svg": "0a12",
	"./tm.svg": "7b74",
	"./tr.svg": "475f",
	"./ua.svg": "e899",
	"./uz.svg": "b9fe",
	"./vn.svg": "e331",
	"./ws.svg": "468b",
	"./za.svg": "7a9a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ba2";